<script>
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let main;
    let content;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            content,
            [
                {duration: 1, y: '0vw'},
                {duration: 1, y: '0vw'},
            ],
            3,
        );
    }
</script>

<div class="main" bind:this={main}>
    <div class="container">
        <div class="contentHolder" bind:this={content}>
            <div class="txt1"><p>Keep up to date</p></div>
            <div class="content">
                <div class="c1"><p>Follow us</p></div>
                <div class="c2"><p>The latest from Opus community</p></div>
            </div>

            <div class="images">
                <div class="im">
                    <video width="100%" height="100%" autoplay loop muted>
                        <source
                            src="images/landingPage/videos/video1.mp4 "
                            type="video/mp4"
                        />
                    </video>
                </div>
                <div class="im">
                    <video width="100%" height="100%" autoplay loop muted>
                        <source
                            src="images/landingPage/videos/video2.mp4 "
                            type="video/mp4"
                        />
                    </video>
                </div>
                <div class="im">
                    <video width="100%" height="100%" autoplay loop muted>
                        <source
                            src="images/landingPage/videos/video3.mp4 "
                            type="video/mp4"
                        />
                    </video>
                </div>
            </div>
        </div>
        <div class="socials">
            <a href="https://twitter.com/OpusAIInc"
            target="__blank"
            >
                <div class="twitter" id="flex">
                    <div class="icon">
                        <img src="images/featuersMobile/Vector1.svg" alt="" />
                    </div>
                    <div class="text"><p id="font">@OpusAIInc</p></div>
                </div>
            </a>
            
            <hr
                style="opacity:0.5; margin:0; margin-top:6.451vw; margin-bottom:5.607vw;"
            />
            <a href="https://www.linkedin.com/company/opusai/"
            target="__blank"
            >
                <div class="linkedin" id="flex">
                    <div class="icon">
                        <img src="images/featuersMobile/Vector2.svg" alt="" />
                    </div>
                    <div class="text"><p id="font">@OpusAI</p></div>
                </div>
            </a>
            <hr
                style="opacity:0.5; margin:0; margin-top:6.451vw; margin-bottom:5.607vw;"
            />
           <a href="https://www.youtube.com/c/opusai"
           target="__blank"
           >
            <div class="youtube" id="flex">
                <div class="icon">
                    <img src="images/featuersMobile/Vector4.svg" alt="" />
                </div>
                <div class="text"><p id="font">@OpusAI</p></div>
            </div>
           </a>
            <hr
                style="opacity:0.5; margin:0; margin-top:6.451vw; margin-bottom:5.607vw;"
            />
            <a href="https://discord.gg/mEWEUkTFHh"
            target="__blank"
            >
                <div class="discord" id="flex">
                    <div class="icon">
                        <img src="images/featuersMobile/Vector3.svg" alt="" />
                    </div>
                    <div class="text"><p id="font">Join Discord</p></div>
                </div>
            </a>
        </div>
        <div class="foot"><p>OPUSAI</p></div>
    </div>
</div>

<style>
    .contentHolder {
        transform: translate(0, 70vw);
    }
    .foot {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 11.458vw;
    }
    .foot p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 1.869vw;
        line-height: 100%;
        color: #d9d9d9;
    }
    .text {
        height: 6.215vw;
        display: flex;
        align-items: center;
    }
    .icon img {
        width: 100%;
        height: 100%s;
    }
    .icon {
        width: 7.009vw;
        height: 6.215vw;
    }
    #font {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.505vw;
        letter-spacing: 0.435em;
        color: #ffffff;
    }
    #flex {
        gap: 7.243vw;
        display: flex;
    }
    .socials {
        margin-top: 21.028vw;
        margin-left: 15.421vw;
    }
    p {
        margin: 0;
    }
    .c1 p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.505vw;
        text-align: right;
        text-transform: uppercase;
        color: #ffffff;
    }
    .c2 p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 900;
        font-size: 7.009vw;
        line-height: 100%;
        color: #ffffff;
    }
    .c1 {
        height: 3.505vw;
        width: 19.86vw;
        transform: rotate(-90deg);
        margin-top: 10vw;
    }
    .c2 {
        height: 14.019vw;
        width: 64.953vw;
        margin-left: -3vw;
    }
    .content {
        display: flex;
        margin-top: 4.673vw;
    }
    .txt1 {
        height: 3.505vw;
        width: 29.206vw;
        margin-left: 13.953vw;
    }
    .txt1 p {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 2.804vw;
        line-height: 3.505vw;
        text-align: right;
        text-transform: uppercase;
        color: #ffffff;
    }
    .im {
        width: 30.14vw;
        height: 30.14vw;
    }
    .im video {
        height: 100%;
        width: 100%;
    }
    .images {
        gap: 4.673vw;
        display: flex;
        margin-top: 12.15vw;
    }
    .main {
        width: 100%;
        height: max(100vh,216vw);
        overflow: hidden;
        background-color: black;
    }
    .container {
        width: 100%;
        margin-top: 49.299vw;
    }
</style>
